import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { HeadElement } from './elements/HeadElement';
import { jsx as _jsx } from "react/jsx-runtime";
var Internal = _ref => {
  var {
    children
  } = _ref;
  return children;
};
var Title = props => /*#__PURE__*/_jsx(HeadElement, _extends({}, props, {
  as: "title"
}));
var Meta = props => /*#__PURE__*/_jsx(HeadElement, _extends({}, props, {
  as: "meta"
}));
var Link = props => /*#__PURE__*/_jsx(HeadElement, _extends({}, props, {
  as: "link"
}));
var Base = props => /*#__PURE__*/_jsx(HeadElement, _extends({}, props, {
  as: "base"
}));
var Style = props => /*#__PURE__*/_jsx(HeadElement, _extends({}, props, {
  as: "style"
}));
var Script = props => /*#__PURE__*/_jsx(HeadElement, _extends({}, props, {
  as: "script"
}));
var Head = Internal;
Head.Meta = Meta;
Head.Title = Title;
Head.Link = Link;
Head.Base = Base;
Head.Style = Style;
Head.Script = Script;
export default Head;